var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLastRelease(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.597,
    height: 21.418,
    viewBox: "0 0 18.597 21.418",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-132.9 -308.66)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#feca2e",
    d: "M3.615-.422a3.25,3.25,0,1,1-3.25,3.25A3.25,3.25,0,0,1,3.615-.422Z",
    transform: "translate(144.632 324)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#c9d1da",
    stroke: "#fff",
    strokeWidth: "0.2px",
    d: "M1935.749-13904.885h-9.092a.68.68,0,0,1-.657-.7v-16.478a.679.679,0,0,1,.657-.7h15.506a.68.68,0,0,1,.657.7v9.46a6.026,6.026,0,0,0-1.314-.156v-8.6h-14.192v15.083h8.155a5.982,5.982,0,0,0,.28,1.394Zm-2.235-5.13h-3.757a.68.68,0,0,1-.657-.7.68.68,0,0,1,.657-.7h3.757a.68.68,0,0,1,.657.7A.68.68,0,0,1,1933.514-13910.015Zm5.137-3.464h-9.006a.679.679,0,0,1-.657-.7.68.68,0,0,1,.657-.7h9.006a.68.68,0,0,1,.657.7A.679.679,0,0,1,1938.651-13913.479Zm0-3.417h-8.845a.68.68,0,0,1-.657-.7.68.68,0,0,1,.657-.7h8.845a.68.68,0,0,1,.657.7A.68.68,0,0,1,1938.651-13916.9Zm.185-6.707h-8.845a.68.68,0,0,1-.657-.7.68.68,0,0,1,.657-.7h8.845a.68.68,0,0,1,.657.7A.679.679,0,0,1,1938.836-13923.6Z",
    transform: "translate(-1793 14233.76)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLastRelease);
export default __webpack_public_path__ + "static/media/lastRelease.01e5e61c.svg";
export { ForwardRef as ReactComponent };